var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.500781,
    y: 0.500781,
    width: 53.9984,
    height: 53.9984,
    stroke: "black",
    strokeWidth: 1.00156
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0744 38C17.0284 38 10.1576 29.7417 9.87134 16H15.9054C16.1036 26.0861 20.5519 30.3584 24.0754 31.2392V16H29.7573V24.6987C33.2368 24.3243 36.892 20.3604 38.1253 16H43.8071C42.8601 21.3734 38.8961 25.3373 36.0773 26.967C38.8961 28.2883 43.4109 31.7458 45.1286 38H38.8741C37.5308 33.8158 34.1838 30.5786 29.7573 30.1381V38H29.0744Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVkIcon);
export default __webpack_public_path__ + "static/media/vk-icon.1b8376f073f115e5f35bcba181d4ae9d.svg";
export { ForwardRef as ReactComponent };